import VueRouter from "vue-router";

import routes from "./routes.js";
import auth from "./auth.js";

let router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  //TODO - Whitelist landing pages/FAQs/login here to allow access without auth
  if (!auth.loggedIn() && !to.path.startsWith("/login")) {
    return next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
  }

  ga("send", "pageview");

  next();
});

export default router;



// WEBPACK FOOTER //
// ./dev/src/router.js